import {
    HeroImage as LandingPageTeaserUi,
    useAnalyticsActionTracker,
    useAnalyticsPageViewTracker,
    useOidcAuthentication,
} from '@cp-shared-10/frontend-ui';
import { withLoadingAndNoConnectionHandler } from 'components/integration-wrapper';
import React from 'react';
import { useLogin } from '../../auth/useLogin';
import { useLandingPageTeaser } from './useLandingPageTeaser';

const LandingPageTeaserWithHandlers = withLoadingAndNoConnectionHandler(LandingPageTeaserUi);

export const LandingPageTeaser: React.FC = () => {
    const { cmsContent: landingPageTeaser, isLoading, loadingError } = useLandingPageTeaser();
    const { isAuthenticated } = useOidcAuthentication();
    const login = useLogin();
    const { onAction } = useAnalyticsActionTracker('login');
    useAnalyticsPageViewTracker('landingPage', !!landingPageTeaser, isAuthenticated);

    const onClick = (): void => {
        onAction();
        login();
    };

    return (
        <LandingPageTeaserWithHandlers
            isLoading={isLoading}
            hasError={!!loadingError}
            title={landingPageTeaser?.title || ''}
            imageUrl={landingPageTeaser?.imageUrl || ''}
            subTitle={landingPageTeaser?.subTitle}
            buttonText={landingPageTeaser?.buttonText}
            clickHandler={onClick}
            inverted={!!landingPageTeaser?.isInverted}
        />
    );
};
